import classNames from 'classnames';
import React from 'react';

interface ToggleTableFiltersButtonProps {
  toggle: () => void;
  toggleModal: () => void;
  active: boolean;
  className?: string;
}

const ToggleTableFiltersButton = ({
  toggle,
  toggleModal,
  active,
  className,
}: ToggleTableFiltersButtonProps) => {
  const onClick = () => {
    if (window.innerWidth > 991) {
      toggle();
    } else {
      toggleModal();
    }
  };

  return (
    <button
      className={classNames('table-header__toggle-filters', {
        'table-header__toggle-filters--active': active,
        [className]: !!className,
      })}
      type="button"
      onClick={() => onClick()}
    >
      <div className="table-header__toggle-filters-label">Filter</div>
    </button>
  );
};

export default ToggleTableFiltersButton;
